import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const ResetInputI18n = {
  configuration: { namespace: I18nNamespace.RESET_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.reset,
  },
};
